module.exports = __webpack_public_path__ + "static/media/logo.be150b5d.svg";